export const findMaxWeight = (weightData) => {
  return weightData.reduce((accumulator, currentItem) => {
    return Math.max(accumulator, currentItem.value);
  }, 0);
};
